<template>
  <div class="score">
    <span>
      {{`${$t('current')}${this.value}`}} &nbsp;
      <el-tooltip :content="$t('level')" placement="top">
        <i class="el-icon-question queston-mark"></i>
      </el-tooltip>
    </span>
    <div class="flex" style="position:relative;margin-top:5px;">
      <el-input-number v-model="score" :min="minScore" :max="10" size="small" :controls="false"></el-input-number>
      <i class="el-icon-minus minus" @click="minus"></i>
      <i class="el-icon-plus plus" @click="plus"></i>
    </div>
    <div class="foot">
      <el-button @click="editScoreConfirm">{{$ct('confirm')}}</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.plus {
  position: absolute;
  top: 6px;
  font-size: 18px;
  right: 8px;
  cursor: pointer;
  color: #c2ebe6;
  &:hover {
    color: #ffc81d;
  }
}
.minus {
  position: absolute;
  top: 6px;
  font-size: 18px;
  left: 8px;
  cursor: pointer;
  color: #c2ebe6;
  &:hover {
    color: #ffc81d;
  }
}
.score {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.foot {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.queston-mark {
  color: rgb(246, 177, 38);
  font-size: 15px;
  top: 10px;
}
</style>

<script>
export default {
  props: {
    value: Number
  },
  data() {
    return {
      score: 0
    }
  },
  computed: {
    // currentScore:{
    //     get(){
    //         return this.value;
    //     },
    //     set(currentScore){
    //         this.$emit('input',currentScore);
    //     }
    // }
    minScore() {
      let min
      if ((0 - this.value) > -10) {
        min = 0 - this.value
      } else {
        min = -10
      }
      return min
    }
  },
  methods: {
    editScoreConfirm() {
      this.$emit('editScoreConfirm', this.score)
    },
    plus() {
      if (this.score <= 10) {
        this.score++
      }
    },
    minus() {
      if (this.score >= -10) {
        this.score--
      }
    }

  }
}
</script>
<i18n lang="yaml">
en:
  current: Class performance
  level: The teacher will increase or decrease by a maximum of 10 points each time.
zh-CN:
  current: 当前表现分
  level: 老师每次最多给学生增加或减少10分
zh-TW:
  current: 當前表現分
  level: 老師每次最多給學生增加或減少10分
it:
  current: Risultati della classe
  level: L'insegnante aumenta o diminuisce fino ad un massimo di 10 punti per volta.
id:
  current: Kinerja Kelas
  level: Guru dapat menambahkan atau mengurangi maksimal 10 poin setiap kali.
</i18n>
